import { z } from "zod";
import moment from "moment";

import i18n from "../../../../../i18n";
import { Command } from "../../types";
import { ELSTER_FIELDS_ENTRIES } from "../../../BWAView/elsterFields";

const elsterCodesEnum = Object.fromEntries(
  ELSTER_FIELDS_ENTRIES.map(([code]) => [code, code])
);

const getTranslation = (key: string, fallback: string): string => {
  return i18n.t(`command.exportEURTransactions.${key}`, {
    defaultValue: fallback,
  });
};

export const FILE_TYPES = ["csv", "pdf"] as const;

export const exportEURTransactionsRequestSchema = z.object({
  command: z.literal(Command.ExportEURTransactions),
  date: z
    .custom<moment.Moment>((val) => moment.isMoment(val), {
      message: getTranslation("invalidDate", "Invalid date"),
    })
    .refine((date) => date.year() <= moment().year(), {
      message: getTranslation("futureDate", "Date cannot be in the future"),
    }),
  fileType: z.enum(FILE_TYPES, {
    invalid_type_error: getTranslation("invalidFileType", "Invalid file type"),
  }),
  elsterField: z
    .string()
    .refine(
      (val): val is string =>
        Object.prototype.hasOwnProperty.call(elsterCodesEnum, val),
      {
        message: getTranslation(
          "elsterField.invalid",
          "Invalid Elster field code"
        ),
      }
    ),
});

export type ExportEURTransactionsFormValues = z.infer<
  typeof exportEURTransactionsRequestSchema
>;
